import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
  selector: "n-modal-body",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content></ng-content>`,
  styleUrls: [
    "./n-modal-body.css",
  ],
})
export class NModalBodyComponent {

}
